import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconChevronTriangleDownMedium"><Path d="M17.2498 9C17.5413 9.00007 17.8064 9.16939 17.9295 9.43359C18.0524 9.69775 18.0114 10.0093 17.824 10.2324L12.574 16.4824C12.4316 16.652 12.2213 16.7499 11.9998 16.75C11.7783 16.75 11.5681 16.652 11.4256 16.4824L6.1756 10.2324C5.98815 10.0093 5.94714 9.6978 6.07013 9.43359C6.19329 9.16937 6.4583 9 6.74982 9H17.2498Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownMedium;
